import React from 'react'
import { CampaignsViewProps } from './Types'
import CampaignViewHeader from './components/CampaignViewHeader/CampaignViewHeader'
import BasicTable from './components/BasicTable/BasicTable'
import CampaignsViewStyle from './Style'
import { CampaignType } from 'graphql/generated/graphql'
import { Box } from '@mui/material'
export default function CampaignsView({
  data,
  setSearchString,
  searchString,
  filterData,
}: CampaignsViewProps): JSX.Element {
  const { campaigns } = data

  const rows = campaigns.map((campaign) => ({
    campaignId: campaign.id,
    name: campaign.name,
    type: campaign.type ?? CampaignType.Query,
    createdAt: campaign.createdAt,
    keywords: campaign.keywords,
    platforms: campaign.platforms,
    hitsCount: campaign.hitsCount,
  }))

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #581c87 50%, #0f172a 100%)',
        padding: '32px',
      }}
    >
      <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
        <CampaignViewHeader
          searchString={searchString}
          setSearchString={setSearchString}
          filterData={filterData}
        />
        <BasicTable
          rows={rows}
          filterData={filterData}
          searchString={searchString}
        />
      </Box>
    </Box>
  )
}
